module.exports = __webpack_public_path__ + "media/assets/images/landing_common/step-3-49d32f5701d7a3f6c35edcd55c733461.png";